export default "__VITE_ASSET__DcpdIr13__"